export default __webpack_public_path__ + "static/media/glrc-course.baking-for-holistic-wellness.ea876463.png";